/**
 * Main template controller of the allMediasViewerGeneric module
 * @param {object} params
 * @param {string} params.title
 * @param {object[]} params.sections
 * @param {string} params.sections[].name
 * @param {string[]} params.sections[].navIcon
 * @param {object[]} params.sections[].subsections
 * @param {boolean} params.sections[].tabs
 * @param {boolean} params.sections[].empty
 * @param {boolean} params.sections[].spinner
 * @param {object[]} params.sections[].subsections
 * @param {string} params.sections[].subsections[].name
 * @param {string} params.sections[].subsections[].label
 * @return {string} - Formatted HTML
 */

const allMediasViewerGenericTpl = (params) => {
  let template = `
<div class="allMediasViewerGeneric js-allMediasViewerGeneric closed">
    <div class="allMediasViewerGeneric-header js-allMediasViewerGeneric-header">
      ${params.title ? `<p class="allMediasViewerGeneric-title">${params.title}</p>` : ''}`;
  if (params.nav === true) {
    template += `
        <ul class="allMediasViewerGeneric-navs">
        ${params.sections.map((section) => '<li class="allMediasViewerGeneric-nav js-allMediasViewerGeneric-nav js-allMediasViewerGeneric-nav--' + section.name + '" data-anchor="' + section.name + '">' + (section.navIcon ? section.navIcon.map((icon) => '<i class="icon icon-' + icon + '"></i>').join('') : '') + (section.label || section.name) + '</li>').join('')}
        </ul>
        `;
  }

  const DOMTabs = params.sections.reduce((acc, section) => {
    return acc.concat(section.subsections.map((subsection) => section.tabs === true ? '<li class="allMediasViewerGeneric-tab js-allMediasViewerGeneric-tab-section--' + section.name + ' js-allMediasViewerGeneric-tab js-allMediasViewerGeneric-tab--' + subsection.name + ' disabled" data-subsection="' + subsection.name + '">' + (subsection.label || subsection.name) + '</li>' : ''));
  }, []).join('');
  if (DOMTabs.length > 0) {
    template += `
          <ul class="allMediasViewerGeneric-tabs">
            ${DOMTabs}
          </ul>
        `;
  }

  template += `
        <span class="allMediasViewerGeneric-close js-allMediasViewerGeneric-close"></span>
    </div>
    <div class="allMediasViewerGeneric-body js-allMediasViewerGeneric-body">`;

  params.sections.forEach(section => {
    template += `
      <div class="allMediasViewerGeneric-section js-allMediasViewerGeneric-section js-allMediasViewerGeneric-section--${section.name}">`;
    section.subsections.forEach(subsection => {
      template += `
      <div class="allMediasViewerGeneric-subsection js-allMediasViewerGeneric-subsection" data-subsection="${subsection.name}">
        ${subsection.label ? `<p class="allMediasViewerGeneric-subtitle">${subsection.label}</p>` : ''}
        <div class="allMediasViewerGeneric-subsection-content"></div>
      </div>
      `;
    });
    template += section.empty ? `<p class="allMediasViewerGeneric-subsection allMediasViewerGeneric-subsection--empty js-allMediasViewerGeneric-subsection--empty disabled">${section.empty}</p>` : '';
    if (section.spinner) {
      template += `
        <div class="cp-spinner">
          <i></i>
        </div>
      `;
    }
    template += '</div>';
  });

  template += `
      <div class="cp-spinner">
        <i></i>
      </div>
    </div>
  </div>
</div>`;

  return template;
};

export {allMediasViewerGenericTpl};